import type { ListBuilderList } from '../../../types';
import { createQuoteCartColumns } from '../columns';
import { CART_MOBILE_CARD_CONFIG, CART_REQUIRED_FIELDS } from '../shared';

/**
 * The quote cart's line list. Identical to the client cart's — a quote line
 * and a cart line are the same record in the same state — except that quote
 * lines may be custom lines, which `cart-item-badges` marks so the empty
 * item-derived cells read as intentional.
 */
export const quoteCartDefaultList: ListBuilderList = {
	id: 'quote_cart_default',
	name: 'Quote Items',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createQuoteCartColumns(),
	description: 'Lines on the quote',
	requiredFields: [...CART_REQUIRED_FIELDS, 'isCustomLine'],
	mobileCardConfig: CART_MOBILE_CARD_CONFIG,
};
